import { useContext, useMemo } from 'react';
import { type SpaceNounForms, resolveSpaceNounForms } from '../../lib/spaceNoun';
import { SpaceNounContext } from './spaceNounContext';

/**
 * Customer-side hook: the tenant's configured "space" noun in four forms.
 * Sourced from `GET /api/customer/branding` via `BrandedShell`.
 */
export function useSpaceNoun(): SpaceNounForms {
  const pair = useContext(SpaceNounContext);
  const singular = pair?.singular ?? null;
  const plural = pair?.plural ?? null;
  return useMemo(() => resolveSpaceNounForms({ singular, plural }), [singular, plural]);
}
